// src/auth/queries.ts
import { queryOptions } from "@tanstack/react-query";

import { api, call } from "@/api/client";

import { session } from "./session";

export const meQuery = queryOptions({
  queryKey: ["me"],
  queryFn: () => call(api.GET("/api/auth/me")),
  staleTime: 5 * 60_000,
});

export const accessQuery = queryOptions({
  queryKey: ["access"],
  queryFn: () => call(api.GET("/api/auth/me/access")),
  staleTime: 60_000,
});

/**
 * الدخول بنموذج form (معيار OAuth2) واسم المستخدم يحمل رقم الجوال. لو الحساب عليه تحقق ثنائي
 * يرمي الخادم 401 بـ mfaRequired=true فتعيد الواجهة الإرسال ومعه otp (رمز التطبيق أو رمز استرداد).
 */
export async function login(phone: string, password: string, otp?: string): Promise<void> {
  const tokens = await call(
    api.POST("/api/auth/token", {
      body: { username: phone, password, ...(otp ? { otp } : {}) } as never,
      bodySerializer: (b: unknown) => new URLSearchParams(b as Record<string, string>),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }),
  );
  session.set(tokens.access_token, tokens.refresh_token);
}

export async function registerUser(input: {
  full_name: string; phone_number: string; password: string;
  account_type?: "INDIVIDUAL" | "VENDOR"; company_name?: string; vat_number?: string; iban_number?: string;
}) {
  return call(api.POST("/api/auth/register", { body: input as never }));
}

/** الدخول برمز SMS بدل كلمة المرور — يُرسل الرمز فقط لو الرقم مسجّل، لكن يرجع نجاح دايماً (منع تعداد الأرقام). */
export async function requestLoginOtp(phone: string): Promise<void> {
  await call(api.POST("/api/auth/otp/request", { body: { phone_number: phone } }));
}

export async function loginWithOtp(phone: string, code: string): Promise<void> {
  const tokens = await call(api.POST("/api/auth/otp/verify", { body: { phone_number: phone, code } }));
  session.set(tokens.access_token, tokens.refresh_token);
}

export async function loginWithGoogle(idToken: string): Promise<void> {
  const tokens = await call(api.POST("/api/auth/google", { body: { id_token: idToken } }));
  session.set(tokens.access_token, tokens.refresh_token);
}
